import React from 'react'
import ModalWrapper from './ModalWrapper'
import ModalFlexOverflow from './ModalFlexOverflow'
import { ModalFlex } from '.'

function Modal({
  children,
  open,
  onClose,
  backgroundColor,
  deleteModal,
  style,
  size = 1,
  containerStyle,
  preventOverflow = false,
  keepMounted = false,
}: IModalProps & IModalDispatch) {
  if (preventOverflow) {
    return (
      <ModalFlexOverflow
        keepMounted={keepMounted}
        open={open}
        onClose={onClose}
        style={containerStyle}
      >
        <ModalWrapper
          size={size}
          backgroundColor={backgroundColor}
          delete={deleteModal}
          style={style}
        >
          {children}
        </ModalWrapper>
      </ModalFlexOverflow>
    )
  } else {
    return (
      <ModalFlex
        keepMounted={keepMounted}
        open={open}
        onClose={onClose}
        style={containerStyle}
      >
        <ModalWrapper
          size={size}
          backgroundColor={backgroundColor}
          delete={deleteModal}
          style={style}
        >
          {children}
        </ModalWrapper>
      </ModalFlex>
    )
  }
}

export default Modal

export interface IModalProps {
  backgroundColor?: string
  children: React.ReactNode
  open: boolean
  title?: string
  deleteModal?: boolean
  style?: React.CSSProperties
  size?: number
  containerStyle?: React.CSSProperties
  preventOverflow?: boolean
  keepMounted?: boolean
}

export interface IModalDispatch {
  onClose: () => void
}
